import styled from '@emotion/styled'
import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import HomeIcon from '../../icons/home.svg'
import { Colors } from '../../styles/colors'
import { Spacing } from '../../styles/spacing'
import { Typography } from '../../styles/typography'
import { blogName } from '../../utils/blog/const'
import { urlForNode } from '../../utils/blog/utils'
import { SiteLink } from '../SiteLink'
import { CATEGORIES_MAP } from './Categories'

const BreadcrumbContainer = styled.ol`
  padding: 4px 0px;
  max-width: 100%;
  display: flex;
  list-style-type: none;
  margin: 0;
  align-content: center;
  ${Colors.Color.eerieBlack600}
  ${Typography.label.label2_400}
  .bread-category {
    flex-shrink: 0;
  }
  .bread-article {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

const Separator = () => <span css={[Spacing.Margin.horizontal_8]}>/</span>
export const Breadcrumb = ({ category, article, className}) => {
  const {site: {siteMetadata : {siteUrl}}} = useStaticQuery(GET_SITE_URL)

  return <BreadcrumbContainer temScope="" itemType="http://schema.org/BreadcrumbList" className={className}>
    <li itemProp="itemListElement" itemScope="" itemType="http://schema.org/ListItem">
     <SiteLink to={`${siteUrl}/${blogName}/`} name="Home" title="Home" itemProp="item" internal>
        <HomeIcon css={Colors.Color.eerieBlack600}/>
     </SiteLink>
      <meta itemProp="position" content="1"/>
    </li>
    <Separator/>
    <li itemProp="itemListElement" className="bread-category" itemScope="" itemType="http://schema.org/ListItem">
      <SiteLink
        to={`${siteUrl}/${blogName}/${CATEGORIES_MAP[category].categoryPath}/`}
        name={CATEGORIES_MAP[category].label}
        title={CATEGORIES_MAP[category].label}
        itemProp="item"
        internal>
        <span itemProp="name" css={[Colors.Color.eerieBlack600]}>{CATEGORIES_MAP[category].label}</span>
      </SiteLink>
      <meta itemProp="position" content="2"/>
    </li>
    {article && (<>
      <Separator/>
      <li itemProp="itemListElement"  className="bread-article" itemScope="" itemType="http://schema.org/ListItem">
        <SiteLink
          to={`${siteUrl}${urlForNode(article)}`}
          title={`${article.title}`}
          name={`${article.title}`}
          itemProp="item"
          internal>
          <span itemProp="name"  css={[Colors.Color.eerieBlack600]}>{article.title}</span>
        </SiteLink>
        <meta itemProp="position" content="3"/>
      </li>
    </>)}
  </BreadcrumbContainer>
}
export const GET_SITE_URL = graphql`
  query HomePageQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }`
